<form [formGroup]="synopticInfoForm" *ngIf="synopticInfoForm">
  <div class="grid">

    <div class="col-12 md:col-12 lg:col-6 xl:col-4">
      <div class="form-field col-12">
        <label for="name">{{'attribute.name' | transloco}} (*)</label>
      </div>
      <div class="col-12">
        <input class="w-full" formControlName="name" id="name" pInputText type="text">
      </div>
      <app-validation-errors [control]="synopticInfoForm.get('name')"></app-validation-errors>
    </div>

    <div class="col-12 md:col-12 lg:col-6 xl:col-4">
      <div class="form-field col-12">
        <label for="description">{{'attribute.description' | transloco}}</label>
      </div>
      <div class="col-12">
        <input class="w-full" formControlName="description" id="description" pInputText type="text">
      </div>
      <app-validation-errors [control]="synopticInfoForm.get('description')"></app-validation-errors>
    </div>

    <div class="col-12 md:col-12 lg:col-6 xl:col-4">
      <div class="form-field col-12">
        <label for="tenant">{{'model.tenant' | transloco}} (*)</label>
      </div>
      <div class="col-12">
        <p-dropdown
          (onChange)="onTenantChange($event)"
          *ngIf="mode === 'create'"
          [filter]="true"
          [options]="tenants"
          [placeholder]="'select.tenant' | transloco"
          dataKey="uuid"
          formControlName="tenant"
          id="tenant"
          optionLabel="name"
          styleClass="w-full"
        ></p-dropdown>
        <div *ngIf="mode === 'edit'" class="custom-input-outline p-disabled">
          {{ synopticInfoForm.get('tenant').value.name }}
        </div>
      </div>
    </div>

    <div class="col-12 lg:col-6 xl:col-4">
      <div class="form-field col-12">
        <label for="organization">{{'model.organization' | transloco}}</label><br>
      </div>
      <div class="col-12">
        <p-dropdown
          (onChange)="onOrganizationChange($event)"
          *ngIf="mode === 'create'"
          [filter]="true"
          [options]="organizations"
          [placeholder]="'select.organization' | transloco"
          [showClear]="true"
          dataKey="uuid"
          formControlName="organization"
          id="organization"
          optionLabel="name"
          styleClass="w-full"
        ></p-dropdown>
        <div *ngIf="mode === 'edit'" class="custom-input-outline p-disabled">
          {{ synopticInfoForm.get('organization').value?.name ?? ('empty.organization' | transloco) }}
        </div>
      </div>
    </div>

  </div>
</form>

<div *ngIf="!synopticInfoForm" class="grid">

  <div class="col-12 md:col-12 lg:col-6 xl:col-4">
    <div class="form-field col-12">
      <label>{{ 'attribute.name' | transloco }} (*)</label>
    </div>
    <div class="col-12">
      <p-skeleton [height]="'33px'"></p-skeleton>
    </div>
  </div>

  <div class="col-12 md:col-12 lg:col-6 xl:col-4">
    <div class="form-field col-12">
      <label>{{ 'attribute.description' | transloco }}</label>
    </div>
    <div class="col-12">
      <p-skeleton [height]="'33px'"></p-skeleton>
    </div>
  </div>

  <div class="col-12 md:col-12 lg:col-6 xl:col-4">
    <div class="form-field col-12">
      <label>{{ 'model.tenant' | transloco }} (*)</label>
    </div>
    <div class="col-12">
      <p-skeleton [height]="'33px'"></p-skeleton>
    </div>
  </div>

  <div class="col-12 lg:col-6 xl:col-4">
    <div class="form-field col-12">
      <label>{{ 'model.organization' | transloco }}</label><br>
    </div>
    <div class="col-12">
      <p-skeleton [height]="'33px'"></p-skeleton>
    </div>
  </div>

</div>
